import React, { useEffect, useState } from "react";
import Navbar from "../../nav";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCakeCandles, faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import axiosInstance from "../../../utils/axiosInstance";
import ProductSkeleton from "../../../utils/ProductSkeleton";

export default function Cakedisplay() {
  const [cakesData, setCakesData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    // Fetch products from the API using axiosInstance directly
    axiosInstance.get('/api/products/getcakes')
      .then((response) => {
        // Assuming data is an array of cakes with a "category" property
        setCakesData(response.data);
        setLoading(false); // Set loading to false once data is fetched
      })
      .catch((error) => {
        console.error('Error fetching cakes:', error);
        setLoading(false); // Set loading to false in case of an error
      });
  }, []);

  const CakeCategory = ({ onSelectCategory, selectedCategory, categories }) => {
    return (
        <div className="flex md:w-5/6 md:mx-auto mx-4 mt-12 justify-between items-center p-1">
        <div className="mx-auto">
          <div className="flex mx-4 text-center place-content-center">
            <div className="border-b-4 border-amber-400 h-4 w-10 sm:w-16 flex items-center justify-center ml-2 sm:ml-5"></div>
            <p className="text-center text-lg sm:text-2xl text-amber-600 font-bold mb-2 font-nav">Cake Menu</p>
            <div className="border-b-4 border-amber-400 h-4 w-10 sm:w-16 flex items-center justify-center ml-2 sm:ml-5"></div>
          </div>
      
          {/* <p className="text-center font-semibold font-roboto text-2xl sm:text-4xl mb-4">Most Browse Cakes </p> */}
      
          <div className="flex space-x-4 md:text-lg md:bg-amber-500 text-sm font-roboto  p-2 rounded-s-xl text-black">
            <button
              key="All"
              className={`text-black rounded-full ${selectedCategory === "All" ? "font-bold text-amber-500" : ""}`}
              onClick={() => onSelectCategory("All")}
            >
              All
            </button>
            {categories.slice(0, 4).map((category) => (
              <button
                key={category}
                className={`text-black ${selectedCategory === category ? "font-semibold text-amber-500" : ""}`}
                onClick={() => onSelectCategory(category)}
              >
                {category}
                
              </button>

            ))}
          </div>
        </div>
      </div>
      
    );
  };

  const CakeList = ({ cakes }) => {
    return (
      <>
        <div className="hidden md:grid md:mx-auto mx-4 grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-2 lg:gap-4 justify-center md:w-5/6">
          {cakes.slice(0, 6).map((cake) => (
            <div key={cake.id} className="p-1 md:p-4">
              
                        <Link to={`/product/${cake._id}`} className="block">

              <div className="max-4 rounded overflow-hidden shadow-lg">
                <img
                  className="w-full h-52 object-cover"
                  src={`${axiosInstance.defaults.baseURL}/${cake.image}`}
                  alt={cake.name}
                />

                <div className="flex justify-between">

                <div className="px-2 py-2 md:px-4 md:py-4 lg:px-6 lg:py-4">
                  <div className="text-lg font-bold font-heading text-amber-500">
                  {cake.name}
                  </div>
                  
                  <div className="text-sm text-gray-500">Rs: {cake.price}</div>

                </div>
                <div className="mt-5 mr-1 ">
                <div className="bg-amber-400 w-9 h-9 rounded-full">
                  <button class="material-symbols-outlined ml-2 ">
                  <Link to={`/product/${cake._id}`}>
                    <FontAwesomeIcon
                      className="mt-2"
                      icon={faShoppingCart}
                      style={{ color: "white", fontSize: "16px" }}
                    />
                     </Link>
                    
                  </button>{" "}
                </div>
              </div>
                </div>
              </div>
              </Link>

            </div>
          ))}
        </div>

        {/* Small device Responsisve */}
        <div className="md:hidden grid grid-cols-2 mx-1 md:grid-cols-3 lg:grid-cols-4 gap-2 justify-center  md:w-5/6">
  {cakes.slice(0, 4).map((cake) => (
    <div key={cake.id} className="p-2 md:p-4">
      <Link to={`/product/${cake._id}`} className="block">
        <div className="max-w-xs rounded overflow-hidden shadow-lg">
          <img
            className="w-full h-32 object-cover"
            src={`${axiosInstance.defaults.baseURL}/${cake.image}`}
            alt={cake.name}
          />
          <div className="px-4 py-4">
            <div className="font-semibold font-heading text-sm mb-2">{cake.name}</div>
            <p className="text-red-500 font-heading font-semibold text-base mb-2">NPR: {cake.price}</p>
          </div>
        </div>
      </Link>
    </div>
  ))}
</div>

      </>
    );
  };

  // Extract unique categories from cakesData
  const categories = Array.from(
    new Set(cakesData.map((cake) => cake.category))
  );

  const filteredCakes =
    selectedCategory === "All"
      ? cakesData
      : cakesData.filter((cake) => cake.category === selectedCategory);

  return (
    <>
      <Navbar />
      <div>
        <CakeCategory
          onSelectCategory={setSelectedCategory}
          selectedCategory={selectedCategory}
          categories={categories}
        />
        {loading ? (
        <ProductSkeleton /> // Display the loading skeleton while data is being fetched
      ) : (
        <>
          <CakeList cakes={filteredCakes} />
        </>
      )}
        <div className="text-center mt-4">
  <Link to="/cake">
    <button className="bg-orange-300 md:w-3/4 w-60 text-white p-2 rounded-md backdrop-blur-sm backdrop-opacity-75 transition duration-300 ease-in-out hover:backdrop-opacity-100">
      Show More
    </button>
  </Link>
</div>
      </div>
    </>
  );
}
